import { jsx } from 'react/jsx-runtime';
import classNames from 'classnames';
import { useTextListContext } from '../TextList.Context/index.es.js';
import { TextListItemContent } from '../TextList.Item.Content/TextList.Item.Content.es.js';
import { TextListItemIcon } from '../TextList.Item.Icon/TextList.Item.Icon.es.js';

const TextListItem = ({ children, className })=>{
    const { size, type } = useTextListContext();
    return jsx("li", {
        className: classNames('cb-text-list-item', `size-${size}`, type, className),
        children: children
    });
};
TextListItem.displayName = 'TextList.Item';
TextListItem.Icon = TextListItemIcon;
TextListItem.Content = TextListItemContent;

export { TextListItem };
//# sourceMappingURL=TextList.Item.es.js.map
